import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import VueAxios from 'vue-axios'
import { plainAxiosInstance, formAxiosInstance } from './api/apiMeta'
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import ArgonDashboard from "./argon-dashboard";
import VueGoogleMaps from '@fawmi/vue-google-maps'
import 'bootstrap/js/dist/carousel.js'
import 'bootstrap/dist/js/bootstrap.bundle';
import $ from 'jquery'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

const appInstance = createApp(App);

appInstance.use(store);
appInstance.use(router);
appInstance.use(ArgonDashboard);
appInstance.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDuWOEpU-ZX8XMioUwcwjbl5Ht_IEUcWRo',
    libraries: 'places',
  },
})
appInstance.use(VueAxios, {
  plain: plainAxiosInstance,
  form: formAxiosInstance,
})
appInstance.use(VueSweetalert2);
appInstance.config.globalProperties.$jQuery = $
appInstance.mount("#app");
